import { CELL_COUNT, Stimulus } from "../types";
import { mulberry32 } from "./random";

const glyphs = ["◌", "◍", "✦", "⊹", "⌁", "⟡", "◒", "◓", "◐", "◑", "◇", "◆", "◎", "✧", "✺", "❖"];
const titles = [
  "The Almost Door", "Left-Hand Thunder", "Borrowed Halo", "Moth Ledger", "Quiet Warning", "Small Volcano",
  "The Friendly Error", "Index of Bees", "Cobalt Whisper", "Argument for Rain", "Tin Compass", "Glass Orchard",
  "Second Moon", "Blue Proof", "Hidden Ladder", "The Soft Alarm", "Borrowed Face", "Triangle Weather",
  "Feather Tax", "Local Eclipse", "Unsent Signal", "Velvet Decimal", "The Fifth Corner", "Map of Noon"
];
const bodies = [
  "A tiny contradiction is parked here.",
  "This tile is trying too hard to be remembered.",
  "Your hand may arrive before your certainty.",
  "A pattern begins, then refuses to finish.",
  "This is not important. That is the trick.",
  "One word is louder than its neighbors.",
  "The edge pretends to be peripheral.",
  "Meaning pulls harder than color.",
  "A change would happen here if you blinked.",
  "The quietest object is collecting evidence.",
  "A social cue without a face.",
  "A little machine for stealing seconds."
];
const families: Stimulus["family"][] = ["edge", "motion", "meaning", "threat", "novelty", "social", "pattern", "quiet"];
const tricks = [
  "change-blindness lure", "inhibition-of-return decoy", "semantic capture", "edge neglect probe",
  "novelty spike", "social-orienting bait", "low-salience sink", "revisit magnet"
];

export function buildStimuli(seed = 1309): Stimulus[] {
  const rand = mulberry32(seed);
  return Array.from({ length: CELL_COUNT }, (_, index) => {
    const family = families[Math.floor(rand() * families.length)];
    const title = titles[(index + Math.floor(rand() * titles.length)) % titles.length];
    const body = bodies[(index * 3 + Math.floor(rand() * bodies.length)) % bodies.length];
    const edgeBoost = index < 12 || index >= 84 || index % 12 === 0 || index % 12 === 11 ? 0.12 : 0;
    const salience = Math.round((0.2 + rand() * 0.68 + edgeBoost) * 100) / 100;
    return {
      id: `stimulus-${index}`,
      index,
      title,
      body,
      glyph: glyphs[(index + Math.floor(rand() * glyphs.length)) % glyphs.length],
      family,
      salience,
      trick: tricks[(index + Math.floor(rand() * tricks.length)) % tricks.length]
    };
  });
}

export const STIMULI = buildStimuli();
